import { render, staticRenderFns } from "./OrderReverse.vue?vue&type=template&id=b1b9f61e&"
import script from "./OrderReverse.vue?vue&type=script&lang=js&"
export * from "./OrderReverse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports